import {IComponentOptions} from "angular";

class AssessmentRowController {

    private onShow: any;

    /* @ngInject */
    constructor(private $log: ng.ILogService) {
    }

    public $onInit() {
    }

    public showAssessment() {
        this.$log.debug("showComments");

        this.onShow({
            $event: {}
        });
    }
}

export const AssessmentRowComponent: IComponentOptions = {
    bindings: {
        assessment: "<",
        selectedAssessmentIds: "=",
        rowIndex: "<",
        actionsEnabled: "<",
        onShow: "&"
    },
    controller: AssessmentRowController,
    template: require("./assessment-row.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/assessment/row/assessment-row.component.ts